<div class="skeleton-loader d-flex align-items-center py-3">
  <div class="skeleton-loader-image me-3"></div>
  <div class="flex-grow-1">
    <div class="skeleton-loader-heading mb-2"></div>
    <div class="skeleton-loader-content"></div>
  </div>
</div>
